<template>
  <div id="q-app">
    <router-view />
    <q-ajax-bar />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
</style>
